import Vue from 'vue'
import App from './App.vue'
import store from './store/index'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router'
import router from './router'
import Axios from 'axios';
import loader from "vue-ui-preloader";
 



Vue.use(VueRouter);
Vue.use(loader);


Vue.config.productionTip = false;

// set auth header
Axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.token}`;

new Vue({
  store,
  vuetify,
    router,
  render: h => h(App)
}).$mount('#app')
